import { apiClient } from '../client';
import type {
  MeResponse,
  NotificationsResponse,
  NotifyResponse,
  StatusResponse,
} from '@/types/api';

export const meApi = {
  get: () => apiClient.get<MeResponse>('/me').then((r) => r.data),

  status: () => apiClient.get<StatusResponse>('/me/status').then((r) => r.data),

  notify: () => apiClient.get<NotifyResponse>('/me/notify').then((r) => r.data),

  notifications: (showAll = false) =>
    apiClient
      .get<NotificationsResponse>('/me/notifications', {
        params: showAll ? { show_all: 1 } : {},
      })
      .then((r) => r.data),

  clearNotifications: () =>
    apiClient.get('/me/clearNotifications').then((r) => r.data),
};
